// @ts-nocheck
/* eslint-disable */

import React, { FC } from 'react';
import { useEffect } from 'react';

export const HeadGoogleTagManager: FC = () => {
  useEffect(() => {
    (function(w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-MPQ4MT3');
  }, []);

  return (
    <noscript
      dangerouslySetInnerHTML={{
        __html: `
          <iframe
            src="https://www.googletagmanager.com/ns.html?id=GTM-MPQ4MT3"
            height="0"
            width="0"
            style="display:none;visibility:hidden"
          ></iframe>
        `,
      }}
    ></noscript>
  );
};
